import Animation from '../../assets/images/Oma-und-Punk2.gif'
import Logo from '../../assets/images/RiGlogo.png'
import Facebook from '../../assets/images/facebook-logo2.png'
import Insta from '../../assets/images/instagram-logo2.png'
import Youtube from './../../assets/images/youtube-logo2.png'
import { RiGFlyer } from '../../components/flyer/flyer'
import { getLargestImageUrl } from '../../utils/image'

import './home.scss'

export default function Home({ homepageData = {} }) {
  const homepageTitle = homepageData.HomepageTitle ?? 'Rohrsheim seit 2007'
  const showAkustikFlyer = false // TODO @sebi: das sollte auch aus `homepageData` kommen!
  const showAkustikFlyerFirst = homepageData.showAkustikFlyerFirst ?? false
  const flyerAssets = homepageData.FlyerOnHomepage?.data ?? []
  const flyerAltTextRig = homepageData.FlyerOnHomepageAltTextRig ?? 'Rock im Garten - Flyer'
  const flyerAltTextAkustik = homepageData.FlyerOnHomepageAltTextAkustik ?? 'Rock im Garten - Akustik Flyer'
  const akustikFlyerAssets = homepageData.AkustikFlyerOnHomepage?.data ?? []
  const flyerFront = getLargestImageUrl(flyerAssets[0])
  const flyerBack = getLargestImageUrl(flyerAssets[1])

  return (
    <div className="home">
      <div className="startAni">
        <img className="logo" src={Logo} alt="Rock im Garten - Logo" />
        <img className="gif" src={Animation} alt="Oma-und-Punk animation" />
        <h1 className='location'>{homepageTitle}</h1>
      </div>
      <div className='links'>
        <a href='https://www.facebook.com/RockimGartenev' target='_blank' title='zum Facebook-Account' rel="noreferrer"><img className="icon" src={Facebook} alt="Rock im Garten Facebook Logo" /></a>
        <a href='https://www.instagram.com/rock_im_garten' target='_blank' title='zum Instagram-Account' rel="noreferrer"><img className="icon" src={Insta} alt="Rock im Garten Instagram Logo" /></a>
        <a href='https://www.youtube.com/@rock_im_garten' target='_blank' title='zum Youtube-Account' rel="noreferrer"><img className="icon" src={Youtube} alt="Rock im Garten Youtube Logo" /></a>
      </div>
      <div className='flyerBox'>
        <RiGFlyer className="flyer" flyerAltTextAkustik={flyerAltTextAkustik} flyerAltTextRig={flyerAltTextRig} showAkustikFlyer={showAkustikFlyer} showAkustikFlyerFirst={showAkustikFlyerFirst} akustikFlyerAssets={akustikFlyerAssets} src={flyerFront} srcHover={flyerBack} />
      </div>
    </div>
  );
}
